"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pagination = exports.search = exports.currency = exports.dataGrid = exports.contactDetailsFormConstants = exports.binaryChoiceDefaultText = exports.modalDefaults = exports.npsScale = exports.defaultSubmitText = exports.defaultAddressFormViewLabel = exports.defaultEditLinkText = exports.validUsStates = exports.amountDue = exports.validationMessages = exports.notFound = exports.oops = exports.default = void 0;
// This file is meant to contain all strings that the components will use
// Location and/or naming should be considered open to criticism
var _default = {
  signIn: 'Sign In',
  signOut: 'Sign Out',
  contactUs: 'Contact Us',
  menu: 'Menu',
  close: 'Close',
  addressInputLabel: 'Address',
  unitNumberLabel: 'Suite or Apt # (optional)',
  cityLabel: 'City',
  stateLabel: 'State',
  zipcodeLabel: 'Zip',
  fileUploader: {
    dragAndDropInstructions: 'Drag & drop here, or',
    browseButton: 'Browse'
  },
  policyCancellation: {
    policyCancellationConfirmation: 'Are you sure you want to cancel your policy?',
    policyCancellationText: "In Colorado, you need to have a workers' comp policy in place \n      if you have even one employee (part-time or full-time).",
    policyCancellationCancelButton: 'Nevermind',
    policyCancellationConfirmButton: 'I Want to Cancel My Policy',
    policyCancellationLink: 'Learn More'
  },
  // coverage selector strings
  perIncident: 'Per Accident',
  perEmployee: 'Per Employee',
  policyLimit: 'Policy Limit'
};
exports.default = _default;
var oops = {
  header: 'It’s not you, it’s us…',
  subHeader: 'Sorry, we\'re not sure what just happened.',
  body: 'We\'ll look into it.  If you need help now, please reach out.'
};
exports.oops = oops;
var notFound = {
  header: 'Shoot.',
  subHeader: 'It looks like that page doesn\'t exist.',
  body: 'If you need help, please feel free to reach out.'
};
exports.notFound = notFound;
var validationMessages = {
  isRequired: 'required',
  validEmail: 'Please provide a valid email address',
  validMultiEmail: 'The following email addresses are invalid: ',
  lettersRequired: 'Letters are required',
  numbersRequired: 'Numbers are required',
  minCharacterCount: 'characters are required',
  maxCharacterCount: function maxCharacterCount(value) {
    return "A maximum of ".concat(value, " characters are allowed");
  },
  minimumValue: function minimumValue(value) {
    return "Value must be ".concat(value, " or greater");
  },
  maximumValue: function maximumValue(value) {
    return "Value must be ".concat(value, " or fewer");
  },
  fein: 'Your FEIN should be formatted as follows: XX-XXXXXXX',
  ssn: 'Your SSN should be formatted as follows: XXX-XX-XXXX',
  phoneTenDigit: 'Please enter in your ten digit phone number',
  coloradoAddress: 'Colorado location required'
};
exports.validationMessages = validationMessages;
var amountDue = {
  followedBy: 'Followed by'
};
exports.amountDue = amountDue;
var validUsStates = ['CO']; // this should not be here - this a program value

exports.validUsStates = validUsStates;
var defaultEditLinkText = 'Edit';
exports.defaultEditLinkText = defaultEditLinkText;
var defaultAddressFormViewLabel = 'Address:';
exports.defaultAddressFormViewLabel = defaultAddressFormViewLabel;
var defaultSubmitText = 'Submit';
exports.defaultSubmitText = defaultSubmitText;
var npsScale = {
  lessLikely: '0 - Not Likely',
  moreLikely: '10 - Very Likely'
};
exports.npsScale = npsScale;
var modalDefaults = {
  alertChoiceModalPositiveResponse: 'Okay',
  alertChoiceModalNegativeResponse: 'Nevermind',
  alertConfirmationModalConfirmationText: 'Okay'
};
exports.modalDefaults = modalDefaults;
var binaryChoiceDefaultText = {
  binaryChoicePositiveText: function binaryChoicePositiveText() {
    return 'Yes';
  },
  binaryChoiceNegativeText: function binaryChoiceNegativeText() {
    return 'No';
  }
};
exports.binaryChoiceDefaultText = binaryChoiceDefaultText;
var contactDetailsFormConstants = {
  defaultFirstNameLabel: 'First Name',
  defaultLastNameLabel: 'Last Name',
  defaultPhoneLabel: 'Phone',
  defaultEmailLabel: 'Email',
  defaultSubmitButton: 'Update Contact'
};
exports.contactDetailsFormConstants = contactDetailsFormConstants;
var dataGrid = {
  filter: 'Filter'
};
exports.dataGrid = dataGrid;
var currency = '$';
exports.currency = currency;
var search = 'Search';
exports.search = search;
var pagination = {
  itemsPerPage: 'Page Size: ',
  items: 'Items',
  pageOf: function pageOf(current, max) {
    return "Page ".concat(current, " of ").concat(max);
  }
};
exports.pagination = pagination;